
let prices,bold;

function storeDefaultPrices(){
  prices.forEach((price)=>{
    price.setAttribute('data-price',price.textContent.replace(/[^0-9\.]/g,''));
  })
}

function showAddonCharge() {
  let addon = document.querySelector('.bold_option_total span');
  prices.forEach((price) => {
    price.textContent = (
      parseFloat(price.getAttribute('data-price')) +
      (addon ? parseFloat(addon.textContent.replace(/[^0-9\.]/g, '')) : 0)
    ).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
  });
}


document.addEventListener('DOMContentLoaded', function() {
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function(event) {
    prices = document.querySelectorAll('.price-item');
    bold = document.querySelector('.bold_option_set');
    storeDefaultPrices()
    bold.addEventListener('change',(event)=>{
      console.log('Change');
      setTimeout(showAddonCharge,500);
    })
  })
})